import { useQuery } from '@tanstack/react-query'
import { MainBannerFn } from '../api/getMainBanner'

interface MainBannerProps {
 b_id: number
 b_link: string
 b_name: string
 b_seo: string
 b_title: string
 b_subtitle: string
 b_status: number
}

export function MainBanner() {
 const { data: banners } = useQuery<MainBannerProps[]>({
  queryKey: ['mainBanners'],
  queryFn: MainBannerFn,
  staleTime: 1000 * 60 * 60 * 24 // 1 dia
 })

 return (
  <>
   {banners?.map(banner => {
    return (
     <div
      className="destaque max-[768px]:h-[200px] max-[991px]:h-[285px] h-[466px] w-full"
      key={banner.b_id}
      title={banner.b_seo}
      aria-label={banner.b_seo}
      style={{
       background: `url(https://www.admancriativa.com.br/assets/img/destaques/${banner.b_name})`
      }}
     >
      <a href={`${banner.b_link}`} className="no-underline">
       <div className="w-full h-full flex items-center bg-black/30">
        <div className="container">
         <div className="max-w-[400px]">
          <span className="font-['rns-milesregular'] font-bold uppercase text-white text-2xl max-[991px]:text-xs tracking-[3px]">
           {banner.b_title}
          </span>
          <h1
           className="font-['rns-milesblack'] font-bold uppercase text-white text-6xl max-[991px]:text-4xl max-[767px]:text-3xl tracking-[3px] leading-[67px] max-[991px]:leading-[42px] max-[767px]:leading-[32px]"
           dangerouslySetInnerHTML={{ __html: banner.b_subtitle }}
          />
         </div>
        </div>
       </div>
      </a>
     </div>
    )
   })}
  </>
 )
}
